import React, { useState, useEffect, useContext, Fragment } from 'react'
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
// import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Grid from '@mui/material/Grid';
import { ObjModal } from '../../../../contexts';
import Checkbox from '../../Datatypes/Checkbox';
import Text from '../../Datatypes/Text';

import { styled } from '@mui/material/styles';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import Typography from '@mui/material/Typography';
import KeyboardArrowRightSharpIcon from '@mui/icons-material/KeyboardArrowRightSharp';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import { removeBorrowersFromLoan } from '../../../../common/api';
import { toast } from 'react-toastify';


function TabPanel( props ) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`tabpanel-${index}`}
        aria-labelledby={`tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            {children}
          </Box>
        )}
      </div>
    );
}


const AutoControls = ( { aid, uid, contacts } ) => {
    const { obj, objType, oid, openModal, closeModal, setModal } = useContext( ObjModal );
    const [ expanded, setExpanded ] = useState( false );
    const [ tabIndex, setTabIndex ] = useState( 0 );
    const [ status, setStatus ] = useState( '' );
    const [ tabs, setTabs ] = useState( [] );

    const handleTabChange = ( event, newValue ) => {
        setTabIndex( newValue );
    };

    const handleModal = ( t ) => {
        let shouldOpen = true;

        switch ( t ) {
            case 'task':
                // setModal( <AddGift close={closeModal} /> ); 
                break;

            default:
                console.log( 'Unknown modal type: ' + t );
                shouldOpen = false;
        }

        if ( shouldOpen ) {
            openModal();
        }
    }

    const AccordionSummary = styled( ( props ) => (
        <MuiAccordionSummary expandIcon={<KeyboardArrowRightSharpIcon sx={{ fontSize: '0.9rem' }} />} {...props} />
    ) ) ( ( { theme } ) => ( {
        backgroundColor:
          theme.palette.mode === 'dark'
            ? 'rgba(255, 255, 255, .05)'
            : 'rgba(0, 0, 0, .03)',
        flexDirection: 'row-reverse',
        '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(90deg)',
        },
        '& .MuiAccordionSummary-content': {
            marginLeft: theme.spacing(1),
        },
    } ) );

    useEffect( () => {
        if ( obj && obj.details && obj.details.status ) {
            setStatus( obj.details.status );

            switch ( obj.details.status ) {
                case 'In Contract':
                    setTabs( [ 'Process', 'Stage', 'Appraisal' ] );
                    break;

                case 'Closed':
                    setTabs( [ 'Post Close Marketing', 'Refi Dates' ] );
                    break;

                default:
            }
        }
    }, [ obj ] );

    useEffect( () => {
        setExpanded( obj.borrowers.length > 0 );
    }, [ obj.borrowers ] );

    return (
        <Container fluid className='p-0'>
            <Accordion expanded={expanded}>
                <AccordionSummary expandIcon={<KeyboardArrowRightSharpIcon onClick={ () => setExpanded( !expanded ) } />}>
                    <Row className='align-items-center w-100'>
                        <Col><Typography>Automation Controls</Typography></Col>
                        {/* <Col xs='auto' className='p-0'><Button variant='outline-primary' size='sm' onClick={ () => handleModal( 'task' ) }>+ Add</Button></Col> */}
                    </Row>
                </AccordionSummary>
                <AccordionDetails>
                    <div>
                        <Tabs value={tabIndex} onChange={ handleTabChange } aria-label="Automated Controls">
                            {
                                tabs.map( ( t, idx ) => <Tab key={`autotab-${idx}`} label={t} /> )
                            }
                        </Tabs>
                        {
                            ( status === 'In Contract' ) ? (
                                <Fragment>
                                    <TabPanel value={tabIndex} index={0}>
                                        <Grid container spacing={3}>
                                            {/* First Column */}
                                            <Grid item xs={6}>
                                                <Checkbox key={`${oid}-contactInfoAutomation`} label={'Contact Info Automation'} db={'contactInfoAutomation'} value={obj.details['contactInfoAutomation']} />
                                                <Checkbox key={`${oid}-hoiOrderAutomation`} label={'HOI Order Automation'} db={'hoiOrderAutomation'} value={obj.details['hoiOrderAutomation']} />
                                                <Checkbox key={`${oid}-titleReqSentCheckbox`} label={'Title Request Automation'} db={'titleReqSentCheckbox'} value={obj.details['titleReqSentCheckbox']} />
                                                <Checkbox key={`${oid}-appraisalOrderedAutomation`} label={'Appraisal Ordered'} db={'appraisalOrderedAutomation'} value={obj.details['appraisalOrderedAutomation']} />
                                            </Grid>

                                            {/* Second Column */}
                                            <Grid item xs={6}>
                                                <Checkbox key={`${oid}-newLEAutomation`} label={'New LE Automation'} db={'newLEAutomation'} value={obj.details['newLEAutomation']} />
                                                <Checkbox key={`${oid}-cdSentAutomation`} label={'CD Sent Automation'} db={'cdSentAutomation'} value={obj.details['cdSentAutomation']} />
                                                <Checkbox key={`${oid}-cdSignedAutomation`} label={'CD Signed Automation'} db={'cdSignedAutomation'} value={obj.details['cdSignedAutomation']} />
                                                <Checkbox key={`${oid}-appraisalReceivedAutomation`} label={'Appraisal Received'} db={'appraisalReceivedAutomation'} value={obj.details['appraisalReceivedAutomation']} />
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value={tabIndex} index={1}>
                                        <Grid container spacing={3}>
                                            {/* First Column */}
                                            <Grid item xs={6}>
                                                <Checkbox key={`${oid}-submittedToUW`} label={'Submitted to UW'} db={'submittedToUW'} value={obj.details['submittedToUW']} />
                                                <Checkbox key={`${oid}-nrAutomation`} label={'NR'} db={'nrAutomation'} value={obj.details['nrAutomation']} />
                                                <Checkbox key={`${oid}-awcAutomation`} label={'AWC'} db={'awcAutomation'} value={obj.details['awcAutomation']} />
                                                <Checkbox key={`${oid}-rcrCheckbox`} label={'RCR'} db={'rcrCheckbox'} value={obj.details['rcrCheckbox']} />
                                            </Grid>

                                            {/* Second Column */}
                                            <Grid item xs={6}>
                                                <Checkbox key={`${oid}-ctcAutomation`} label={'CTC'} db={'ctcAutomation'} value={obj.details['ctcAutomation']} />
                                                <Checkbox key={`${oid}-instructionsOutAutomation`} label={'Instructions Out'} db={'instructionsOutAutomation'} value={obj.details['instructionsOutAutomation']} />
                                                <Checkbox key={`${oid}-cdApprovedAutomation`} label={'CD Approved'} db={'cdApprovedAutomation'} value={obj.details['cdApprovedAutomation']} />
                                                <Checkbox key={`${oid}-closedAutomation`} label={'Closed'} db={'closedAutomation'} value={obj.details['closedAutomation']} />
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value={tabIndex} index={2}>
                                        <Grid container spacing={3}>
                                            {/* First Column */}
                                            <Grid item xs={12}>
                                                <Text key={`${oid}-appraisalOrderedDate`} label={'Appraisal Ordered'} db={'appraisalOrderedDate'} value={obj.details['appraisalOrderedDate']} type={'date'} disabled={false} />
                                                <Text key={`${oid}-appraisalDueDate`} label={'Appraisal Due Date'} db={'appraisalDueDate'} value={obj.details['appraisalDueDate']} type={'date'} disabled={false} />
                                                <Text key={`${oid}-appraisalInDate`} label={'Appraisal Received'} db={'appraisalInDate'} value={obj.details['appraisalInDate']} type={'date'} disabled={false} />
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                </Fragment>
                            ) : ( status === 'Closed' ) ? (
                                <Fragment>
                                    <TabPanel value={tabIndex} index={0}>
                                        <Grid container spacing={3}>
                                            {/* First Column */}
                                            <Grid item xs={12}>
                                                <Checkbox key={`${oid}-sendMiscMarketing`} label={'Send Misc Marketing Emails'} db={'sendMiscMarketing'} value={obj.details['sendMiscMarketing']} />
                                                <Checkbox key={`${oid}-sendAnniversaryMarketing`} label={'Send Anniversary Marketing'} db={'sendAnniversaryMarketing'} value={obj.details['sendAnniversaryMarketing']} />
                                                <Checkbox key={`${oid}-homeValuationUpdate`} label={'Home Valuation Update'} db={'homeValuationUpdate'} value={obj.details['homeValuationUpdate']} />
                                                <Checkbox key={`${oid}-sendAMR`} label={'Send Annual Mortgage Reviews'} db={'sendAMR'} value={obj.details['sendAMR']} />
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                    <TabPanel value={tabIndex} index={1}>
                                        <Grid container spacing={3}>
                                            {/* First Column */}
                                            <Grid item xs={12}>
                                                <Text key={`${oid}-refiContactDate`} label={'Refinance Contact'} db={'refiContactDate'} value={obj.details['refiContactDate']} type={'date'} disabled={false} />
                                                <Text key={`${oid}-refinancedDate`} label={'Refinanced Date'} db={'refinancedDate'} value={obj.details['refinancedDate']} type={'date'} disabled={false} />
                                            </Grid>
                                        </Grid>
                                    </TabPanel>
                                </Fragment>
                            ) : (
                                null
                            )
                        }
                    </div>
                </AccordionDetails>
            </Accordion>
        </Container>
    )
}

const mapProps = ( state ) => ( {
    aid: state.user.aid,
    uid: state.user.email,
    contacts: state.contacts.byId
} );

const mapDispatch = ( dispatch ) => ( {
} );

export default connect( mapProps, mapDispatch )( AutoControls );